var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mu-col',{staticClass:"col-12"},[_c('center',[_c('img',{staticClass:"content-image",attrs:{"src":_vm.image_src}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }